export default "__VITE_ASSET__08582590__"